import axios from 'axios';

const API = '/api';
const ALERTS_PATH = `${API}/alert`;
class AlertService {
  async getAlerts() {
    const url = `${ALERTS_PATH}`;
    const alerts = await axios.get(url);
    return alerts;
  }
  updateEmployeeAlerts(params) {
    const url = `${ALERTS_PATH}`;
    axios.put(url, params.alertIds);
  }
}
export default new AlertService(); // singleton object
